import React from 'react';

/**
 * Template 9: Statement + Emphasis
 * Dark bg, subject image, large serif text bottom-left,
 * one key word underlined in red or bold.
 *
 * Inspired by: "Energy is NOT conserved"
 */
export default function V_StatementEmphasis({
  headline = 'Energy is NOT conserved',
  subjectImage,
  bgColor = '#0a0a0a',
  accentColor = '#E53935',
  emphasisWord = 'NOT',
}) {
  // Split headline around emphasis word
  const words = headline.split(' ');

  return (
    <div style={{
      width: 1280, height: 720, position: 'relative', overflow: 'hidden',
      background: bgColor, fontFamily: "'Playfair Display', serif",
    }}>
      {/* Subject image - center-right */}
      {subjectImage ? (
        <div style={{
          position: 'absolute', right: 40, top: '50%', transform: 'translateY(-50%)',
          width: 700, height: 600, zIndex: 1,
        }}>
          <img src={subjectImage} alt="" style={{
            width: '100%', height: '100%', objectFit: 'contain',
          }} />
        </div>
      ) : (
        <div style={{
          position: 'absolute', right: 100, top: '50%', transform: 'translateY(-50%)',
          width: 500, height: 420, background: 'rgba(255,255,255,0.04)',
          borderRadius: 12, zIndex: 1,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 32, color: 'rgba(255,255,255,0.1)',
        }}>SUBJECT</div>
      )}

      {/* Statement text - bottom left */}
      <h1 style={{
        position: 'absolute', bottom: 60, left: 60,
        margin: 0, fontSize: 100, fontWeight: 700, lineHeight: 1.1,
        color: '#FFFFFF', zIndex: 2,
        maxWidth: 800,
        textShadow: '0 4px 20px rgba(0,0,0,0.8)',
      }}>
        {words.map((word, i) => {
          const isEmphasis = word.toLowerCase() === emphasisWord.toLowerCase();
          return (
            <span key={i}>
              {isEmphasis ? (
                <span style={{
                  fontWeight: 800,
                  textDecoration: 'underline',
                  textDecorationColor: accentColor,
                  textDecorationThickness: 6,
                  textUnderlineOffset: 8,
                }}>{word}</span>
              ) : word}
              {i < words.length - 1 ? ' ' : ''}
            </span>
          );
        })}
      </h1>
    </div>
  );
}
